var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// client/extensions/ContainerFlexExtension.ts
import { html } from "lit";
import { customElement } from "lit/decorators.js";
import { BaseContainerFlex } from "../../db/extensions/BaseContainerFlex.js";
import "../components/x-buildify-color-picker.js";
import { ContainerExtension, XContainerExtension } from "./ContainerExtension.js";
import { EditExtensionData } from "./EditExtensionData.js";
var ContainerFlexExtension = {
  class: BaseContainerFlex,
  toolbar: { icon: "flex_wrap", text: { default: "Flex" } },
  defaultValues: {
    ...ContainerExtension.defaultValues,
    flexDirection: { global: "column" }
  },
  render(instance, { isSubelement, dropzoneBefore, dropzoneAfter }) {
    return html`
      <x-container-flex-extension
        .content=${instance}
        .defaultValues=${this.defaultValues}
        ?sub=${isSubelement}
        .hasDropzoneBefore=${dropzoneBefore}
        .hasDropzoneAfter=${dropzoneAfter}
      ></x-container-flex-extension>
    `;
  },
  editor({ content, contentController, controllerBaseKeyPath, host, globalSettings, extensions }) {
    return html`
      <x-flex space="sm">
        <x-buildify-spacing-picker
          select
          clearable
          placeholder="Zeilen-Abstand"
          select
          ${contentController.field(...controllerBaseKeyPath, "rowGap")}
        ></x-buildify-spacing-picker>
        <x-buildify-spacing-picker
          select
          clearable
          placeholder="Spalten-Abstand"
          select
          ${contentController.field(...controllerBaseKeyPath, "columnGap")}
        ></x-buildify-spacing-picker>
        <x-dropdown-selection
          clearable
          placeholder="Richtung"
          .selectables=${["row", "column"]}
          ${contentController.field(...controllerBaseKeyPath, "flexDirection")}
          .renderString=${(str) => str ? { row: "Horizontal", column: "Vertikal" }[str] ?? "" : ""}
        ></x-dropdown-selection>
        <x-dropdown-selection
          clearable
          placeholder="Anordnung entlang der Richtung"
          .selectables=${["flex-start", "center", "flex-end", "space-between", "space-around"]}
          ${contentController.field(...controllerBaseKeyPath, "justifyContent")}
        ></x-dropdown-selection>
        <x-dropdown-selection
          clearable
          placeholder="Anordnung entgegen der Richtung"
          .selectables=${["flex-start", "center", "flex-end", "space-between", "space-around", "stretch"]}
          ${contentController.field(...controllerBaseKeyPath, "alignItems")}
        ></x-dropdown-selection>

        ${EditExtensionData({
      host,
      content: {
        value: content,
        path: controllerBaseKeyPath,
        controller: contentController,
        extension: ContainerExtension
      },
      globalSettings,
      extensions
    })}
      </x-flex>
    `;
  },
  group: "Layout"
};
var XContainerFlexExtension = class extends XContainerExtension {
  styles() {
    return [
      ...super.styles(),
      {
        ":host": {
          display: "flex",
          flexDirection: this.getValue("flexDirection"),
          rowGap: this.getValue("rowGap"),
          columnGap: this.getValue("columnGap"),
          justifyContent: this.getValue("justifyContent"),
          alignItems: this.getValue("alignItems"),
          // in edit mode, add this style
          ...this._consumedMode.value === "edit" && !this.isSubContent ? {
            border: "1px solid #333",
            padding: "10px"
            // marginBottom: '10px',
          } : {}
        },
        // hover styling
        "[edit-hover]": {
          width: "14px",
          height: "14px",
          background: "#333"
        }
      }
    ];
  }
};
XContainerFlexExtension = __decorateClass([
  customElement("x-container-flex-extension")
], XContainerFlexExtension);
export {
  ContainerFlexExtension,
  XContainerFlexExtension
};
